module.exports = __webpack_public_path__ + "static/media/HT.1498fcb0.svg";